import {
  Alert,
  Button,
  CircularProgress,
  Container,
  Divider,
  Snackbar,
} from "@mui/material";
import module from "./RewardSetting.module.css";
import { useContext, useEffect, useState } from "react";
import FormSelfInformation from "../components/reward/setting/FormSelfInformation";
import FormBankData from "../components/reward/setting/FormBankData";
import { RewardSettingContext } from "../contexts/RewardSettingContext";
import ConfirmModal from "../components/reward/setting/ConfirmModal";
import { useNavigate } from "react-router-dom";
import FormPersonalInput from "../components/reward/setting/FormPersonalInput";
// import EkycModal from "../components/reward/setting/EkycModal";

const RewardSetting = () => {
  const { pageStatus, handleSubmit, handleClose, getUserInfo, user } =
    useContext(RewardSettingContext);
  const { isLoaded, open } = pageStatus;
  const navigate = useNavigate();

  const isFinishEKyc = () => {
    if (!user) return false;
    if (!user.attributes) return false;
    if (user.attributes["custom:finish_manual_ekyc"]) return true;
    if (!user.attributes["custom:isFinishEKyc"]) return false;
    return user.attributes["custom:isFinishEKyc"];
  }

  useEffect(() => {
    getUserInfo();
  }, []);

  const handleClick = () => {
    navigate("/mypage/reward/setting/ekyc/start");
  }

  const RequestEKyc = () => (
    <div>
      <div>
        <p>本人確認ツールにて、本人確認書類と本人確認を実施してください</p>
      </div>
      <div>
        <Button
          variant="contained"
          onClick={handleClick}
        >
          本人確認を実施する
        </Button>
      </div>
      <div>
        <p>終了後、口座情報を入力いただけます</p>
      </div>
    </div>
  );

  const SettingForm = () => (
    <form onSubmit={handleSubmit}>
      <div className={module.formContainer}>
        <FormSelfInformation />
        <FormBankData />
      </div>
      <Button
        variant="contained"
        color="primary"
        sx={{
          width: "100%",
          fontWeight: "bold",
          borderRadius: "0px",
          padding: "12px 0px",
        }}
        type="submit"
      >
        お振込情報を{`${pageStatus.isInputted ? "更新" : "保存"}`}
      </Button>
    </form>
  );


  if (isLoaded) return <CircularProgress color="success" />;

  return (
    <div className={module.container}>
      <div>
        <h1 className={module.title}>報酬設定</h1>
      </div>
      <Divider />
      <Container
        sx={{
          padding: "0px",
        }}
      >
        {isLoaded && <CircularProgress color="success" />}
        {!isLoaded && !isFinishEKyc() && (<FormPersonalInput />)}
        {!isLoaded && isFinishEKyc() && (<SettingForm />)}
      </Container>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={open}
        onClose={handleClose}
        key={"top" + "center"}
        security="success"
        autoHideDuration={10000}
      >
        <Alert severity="success">設定を保存しました。</Alert>
      </Snackbar>
      <ConfirmModal />
    </div>
  );
};

export default RewardSetting;
